export const SERVICE_TYPE_ORDER = [
  "Truckload",
  "LTL",
  "Boats",
  "Warehousing",
  "Vehicles: Cars",
  "Vehicles: RVs",
  "Vehicles: Motorcycles",
];

export function serviceImageUrl(apiBase, imagePath) {
  if (!imagePath || typeof imagePath !== "string") return "";
  const t = imagePath.trim();
  if (/^https?:\/\//i.test(t)) return t;
  const rel = t.replace(/^\/+/, "");
  return `${apiBase}/${rel}`;
}

export function normalizeServiceItems(data) {
  if (!Array.isArray(data) || data.length === 0) return null;
  const orderIndex = new Map(SERVICE_TYPE_ORDER.map((k, i) => [k, i]));
  const items = data
    .filter((item) => item && item.type === "service" && item.serviceType)
    .map((item) => ({
      _id: item._id,
      title: item.title ?? "",
      subtitle: item.subtitle ?? "",
      text: item.text ?? "",
      type: item.serviceType,
      image: item.image ?? "",
    }));
  if (items.length === 0) return null;
  items.sort((a, b) => {
    const ia = orderIndex.has(a.type) ? orderIndex.get(a.type) : 999;
    const ib = orderIndex.has(b.type) ? orderIndex.get(b.type) : 999;
    if (ia !== ib) return ia - ib;
    return String(a.title).localeCompare(String(b.title));
  });
  return items;
}
